import { ButtonsRowWithTitle } from 'components/Button';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMTable, {
  RowEditProps,
  TableProps,
} from 'components/customComponents/Controls/RMTable';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useCallback } from 'react';
import {
  getNewId,
  getRequiredFiledsError,
  getUserId,
  isNullOrUndefined,
  showAlertSnackBar,
} from 'utils/Global';
import {
  ProtectantAgentTitle,
  ProtectantAgentType,
  actionButtonBaseProps,
  actionButtonStyle,
} from './constants';
import './styles.scss';
import { ModalDetails } from 'business/models/CustomModels';
import RMModal from 'components/modal/RMModal';
import { getHideModalHandler } from './utils';
interface Props {
  protectantAgentType: ProtectantAgentType;
  buttons: RMCustomButtonProps[];
  tableProps: Omit<TableProps, 'rowEditProps' | 'onCheckboxSelectionChange'>;
  setSelectedRows: (...args) => void;
  editedData: any;
  setEditedData: (...args) => void;
  setProtectantData: (any) => void;
  editId: number;
  setEditId: React.Dispatch<React.SetStateAction<number>>;
  saveUpdateProtectantHandler: (...args) => void;
  modalDetails: ModalDetails;
  setModalDetails: React.Dispatch<React.SetStateAction<ModalDetails>>;
}
const ProtectantAgents = (props: Props) => {
  const {
    protectantAgentType,
    buttons,
    tableProps,
    setSelectedRows,
    editedData,
    setEditedData,
    setProtectantData,
    editId,
    setEditId,
    saveUpdateProtectantHandler,
    modalDetails,
    setModalDetails,
  } = props;

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows([...rowIndices]);
  };

  const rowEditCompleteHandler = useCallback((row) => {
    setEditedData(row);
  }, []);

  const hideModalHandler = getHideModalHandler(setModalDetails);

  const handleRemoveProtectantAgent = (index) => {
    const updatedList = [...tableProps.data];
    updatedList.splice(index, 1);
    setProtectantData(updatedList);
  };

  const handleOnRowDisard = () => {
    if (isNullOrUndefined(editedData.id)) {
      handleRemoveProtectantAgent(rowEditProps.currentEditingRowId);
    }
    setEditId(null);
    setEditedData(null);
  };

  const handleOnRowSave = async () => {
    const errorMessage = getRequiredFiledsError(editedData, [
      { accessor: 'ingredient', title: 'Ingredient' },
      { accessor: 'conc', title: 'Concentration' },
      { accessor: 'concUnit', title: 'Concentraton Units' },
    ]);
    if (errorMessage) {
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, errorMessage);
    } else {
      if (isNullOrUndefined(editedData?.id)) {
        editedData.id = getNewId();
        editedData.userId = await getUserId();
      }
      setEditId(null);
      setEditedData(null);
      saveUpdateProtectantHandler([editedData]);
    }
  };

  const saveDiscardButtons = [
    <div
      key={`protectant-agents-actions`}
      className="h-full w-[1px] bg-[#B4B4B4] py-[0.125rem]"
    />,
    {
      iconProps: {
        name: 'Close',
        ...actionButtonBaseProps,
      },
      isDisabled: editId === null,
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: '#da1e28',
      },
      onClick: handleOnRowDisard,
      titleTip: 'Discard',
    },
    {
      iconProps: {
        name: 'checkMark',
        ...actionButtonBaseProps,
      },
      contentContainerStyle: actionButtonStyle,
      isDisabled: editId === null,
      onClick: handleOnRowSave,
      titleTip: 'Save',
    },
  ];

  const rowEditProps: RowEditProps = {
    currentEditingRowId: editId,
    setCurrentEditingRowId: setEditId,
    handleOnCellContentEditComplete: rowEditCompleteHandler,
    showActionButtons: false,
    showEditButton: false,
    rowDiscardHandler: handleOnRowDisard,
    rowSaveHandler: handleOnRowSave,
  };

  return (
    <div id={`exp-protectantagents-wrapper`} className="h-[70vh] mx-2 my-2 border-solid border-[1px] border-[#E0E0E0]">
      <div id={`exp-protectantagents-title`} className="m-2">
        <ButtonsRowWithTitle
          title={ProtectantAgentTitle[protectantAgentType]}
          buttonsList={[...buttons, ...saveDiscardButtons]}
          marginBetweenItems={'0.5rem'}
        />
      </div>
      <div id={`exp-protectantagents-cryotable`} className="cryo-table h-full overflow-auto">
        <RMTable
          {...tableProps}
          onCheckboxSelectionChange={handleSelectionChange}
          rowEditProps={rowEditProps}
        />
      </div>
      <RMModal id='exp-protectantagents-modaldetails'
        {...modalDetails}
        setShowModal={hideModalHandler}
        onCancel={hideModalHandler}
      />
    </div>
  );
};

export default ProtectantAgents;
